// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-deals-table[data-v-77ba946a] {\n  width: 100%;\n}\n.table-striped > tbody > tr[data-v-77ba946a]:nth-of-type(odd) {\n  background: #f1f3f6;\n}\n.table-striped > tbody > tr[data-toggle][data-v-77ba946a]:hover,\n.table-striped > tbody > tr[data-href][data-v-77ba946a]:hover,\n.table-striped > tbody > tr.active[data-v-77ba946a] {\n  background: #eaeaea;\n}\n.table td[data-v-77ba946a] {\n  padding: 8px 12px;\n}\n.table th[data-v-77ba946a] {\n  min-width: 90px;\n}\n", ""]);
// Exports
module.exports = exports;
